import React from 'react';
import Hero from '../components/Hero';
import Services from './Services';
import AboutSection from '../components/AboutSection';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';
import Portfolio from './Portfolio';
import '../styles/Home.css';
import Estimator from './Estimator';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      {/* <div className="section-block"> */}
      <Services />
      {/* </div> */}
      <div className="section-block">
        <Portfolio />
      </div>
      {/* <div className="section-block"> */}
      <Estimator />
      {/* </div> */}
      {/* <div className="section-block"> */}
      <AboutSection />
      {/* </div> */}
      {/* <div className="section-block"> */}
      <Testimonials />
      {/* </div> */}
      {/* <div className="section-block"> */}
      <CTASection />
      {/* </div> */}
    </div>
  );
};

export default Home;
